import { createSlice } from '@reduxjs/toolkit';
import { addToDatabaseCart, getDatabaseCart, removeFromDatabaseCart } from '../../utilities/databaseManager';



const initialState = {
    counter: 1,
    click: false,
    setOpen: false,
    cartData: []
}

const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        getInitialCounter: (state, action) => {
            const getInitialCartData = getDatabaseCart();
            const initialCounter = (uniqueId) => {
                for (let key in getInitialCartData) {
                    if (key === uniqueId) {
                        return getInitialCartData[key]
                    }
                }
            }
            state.counter = initialCounter(action.payload) || 1;
            state.open = false;
        },
        increment: (state, action) => {
            state.counter++
        },
        decrement: (state, action) => {
            state.counter--
        },
        addToCart: (state, action) => {
            const { id, counter } = action.payload
            addToDatabaseCart(id, counter);
            state.click = true;
            state.open = true;
        },
        removeFromCart: (state, action) => {
            removeFromDatabaseCart(action.payload)
        },
        click: (state, action) => {
            state.click = action.payload;
        },
        openPopup: (state, action) => {
            state.open = action.payload;
        },
        cartData: (state, action) => {
            state.cartData = action.payload
        }
    }
})

export default cartSlice.reducer
export const { increment, decrement, addToCart, click, openPopup, getInitialCounter, cartData, removeFromCart } = cartSlice.actions